import { ModalAjax } from './ModalAjax';

/**
 * @param {HTMLButtonElement} element
 */
export function showReviewAgreements(element) {
	const modal = new ModalAjax();
	modal.title = element.dataset.modalTitle;
	modal.contentUrl = element.dataset.url;
	modal.buttons = [
		modal.$createElement('div', { class: 'd-flex flex-row justify-content-center mt-4' }, [
			modal.$createElement('button', {
				class: 'button button_theme_secondary map-btn button_width_200',
				attrs: {
					dataDismiss: 'modal'
				},
				on: {
					click: function() {
						modal.$refs.modal.hide();
					}
				}
			}, 'Закрыть'),
		])
	];
	modal.$mount();
}
